// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac786000","667":"9b307596","977":"09b1b665"}[chunkId] + ".chunk.js";
};